import Grid from "@mui/material/Grid2";
import React from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";

const name = "Benefits"

const createData = (feature: string, benefit: string) => ({ feature, benefit });

const rows = [
    createData('12 month guarantee', "We believe in our engineers' ability to get the job done right the first time. We provide you with a 12-month guarantee, so if something goes wrong you can rest assured we will be here to help."),
    createData('5 Years experience', "Our Gas Safe and NICEIC accredited engineers have a minimum 5 years of experience and deal with this type of problem daily. So you can feel confident that the job will be done to the highest standard."),
    createData('Worcester accredited', "You are in safe hands with us as our engineers are Worcester Bosch accredited in providing repairs and installation services."),
    createData('Open 365', "Our offices are open 365 days of the year so when the unexpected happens on the worst of days we'll be here to help."),
    createData('Flexibility to suit you', 'We offer a time that suits you, so we work around your schedule to fit your needs.'),
];

type Props = {
    parent: string
}

const Benefits: React.FC<Props> = ({ parent }) => {
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, {})
    return (
        (<Grid container >
            <Grid
                size={{
                    xs: 12,
                    sm: 12
                }}>
                <TableContainer >
                    <Table sx={{ minWidth: 400 }} size="small" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    padding: 0.2,
                                    pl: 1
                                }}>Feature</TableCell>
                                <TableCell sx={{
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    padding: 0.2,
                                    pl: 1
                                }} align="left">Benefit</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row: any, idx: number) => (
                                <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:nth-of-type(even)': { backgroundColor: "#0000000f", } }}>
                                    <TableCell sx={{ p: 0.4, px: 1 }} component="th" scope="row">{row.feature}</TableCell>
                                    <TableCell sx={{ p: 0.4, px: 1 }} align="left">{row.benefit}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid >)
    );
}

export default Benefits